import CreateModal from './modals/CreateModal';
import MessagesSnackbar from '../../../components/shared/MessagesSnackbar';
import { useContext } from 'react';
import { TrainingMaterialContext, TrainingMaterialValues } from '../contexts/TrainingMaterialContext';

const TrainingAreaPopUps=() => {
  const { closeSnackBar,
    isSnackBarOpen,
    snackBarSeverity,
    snackbarMessage,
    snackBarDuration,
  } = useContext(TrainingMaterialContext) as TrainingMaterialValues;
    
  return (
    <>
      <CreateModal/>
      <MessagesSnackbar onClose={closeSnackBar}
        open={isSnackBarOpen}
        severity={snackBarSeverity}
        message={snackbarMessage}
        duration={snackBarDuration}/>
    </>
  );
};

export default TrainingAreaPopUps;